module.exports = __webpack_public_path__ + "static/img/wsbxh1.07df33d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wsbxh1.png
// module id = Inj+
// module chunks = 1